import { Component, OnInit } from '@angular/core';
import { LEGAL_ENTITY_ID } from 'src/app/shared/utils/legal-entityid.util';
import { SubNavbarService } from 'src/app/services/sub-navbar.service';
import { jsPDF } from 'jspdf';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-sub-navbar',
  templateUrl: './sub-navbar.component.html',
  styleUrls: ['./sub-navbar.component.scss']
})
export class SubNavbarComponent implements OnInit {

  loading = false
  timeFilter: string = '3month'
  companyFilter: any = { type: 'all', id: null }
  companies: any = []
  toggle = "dropdown";
  selectedBranch?: String = '';

  constructor(private readonly subNavbarService: SubNavbarService, private readonly reportsSvc: ReportsService) { }

  ngOnInit(): void {
    this.subNavbarService.selectedFilter$.subscribe(filter => {
      this.timeFilter = filter.time;
      this.companyFilter = filter.company;
    })
    this.getCompanies()
  }

  getCompanies() {
    this.subNavbarService.getAllCompanies().subscribe(
      (data) => {
        this.companies = data
      },
    )
  }

  changeTimeFilter(timeFilter: string) {
    this.subNavbarService.setFilter(
      {
        time: timeFilter,
        company: this.companyFilter
      });
  }

  changeCompanyFilter(companyId: any) {
    this.companyFilter = {
      id: companyId.target.value == 'null' ? null : companyId.target.value,
      type: this.companies.filter((company: any) => company._id === companyId.target.value)[0]?.type ?? 'all'
    },
      this.subNavbarService.setFilter(
        {
          time: this.timeFilter,
          company: this.companyFilter
        });
  }

  toPdf() {

    const domToImage = require('dom-to-image');
    const dashboard = document.getElementById('superAdminKPI');

    const dashboardHeight = dashboard?.clientHeight ?? 0;
    const dashboardWidth = dashboard?.clientWidth ?? 0;
    const options = { background: 'white', width: dashboardWidth + 100, height: dashboardHeight + 100 };

    this.loading = true

    domToImage.toPng(dashboard, options).then((imgData: any) => {
      this.loading = false
      //const doc = new jsPDF('p', 'mm', 'letter');
      const doc = new jsPDF(dashboardWidth > dashboardHeight ? 'l' : 'p', 'mm', [dashboardWidth, dashboardHeight]);
      const imgProps = doc.getImageProperties(imgData);
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      doc.addImage(imgData, 'PNG', 10, 0, pdfWidth, pdfHeight);
      let companyName = this.companies.filter((company: any) => company._id === this.companyFilter.id)[0]?.name
      doc.save(companyName ?
        companyName + '.pdf' : 'Total contratistas.pdf');
    });
  }

  generateExcel() {
    this.loading = true
    this.subNavbarService.generateExcelReport(LEGAL_ENTITY_ID, this.timeFilter, this.companyFilter.id)
      .subscribe((data) => {
        this.loading = false
        console.log('[SubNavbarComponent][S3 private flow] KPI report response', data);
        this.reportsSvc.openDownload(data, 'Global_Report.xlsx');
      },
        (error) => {
          this.loading = false
          console.error(error, "No se pudo generar el excel del reporte.")
        });
  }

  onSelect(event: TypeaheadMatch): void {
    console.log(event);
    this.companyFilter = {
      id: event.item._id,
      type: event.item.type ?? 'all'
    };
    console.log(this.companyFilter);
    this.subNavbarService.setFilter(
      {
        time: this.timeFilter,
        company: this.companyFilter
      });
  }

  cleanFilter() {
    this.toggle = "dropdown";
    this.selectedBranch = '';
    this.companyFilter = {
      id: null,
      type: 'all'
    },
      this.subNavbarService.setFilter(
        {
          time: this.timeFilter,
          company: this.companyFilter
        });
  }

}
